import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Form, Input } from 'grab-ui';

import css from './input-field.less';

const cx = classnames.bind(css);
const FormItem = Form.Item;

const InputField = ({
  id,
  placeholder,
  className,
  prefix,
  suffix,
  type,
  disabled,
  fieldClassName,
  fieldOptions,
  form,
  onBlur,
  autoComplete,
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem className={cx('formItem', fieldClassName)}>
      {getFieldDecorator(id, fieldOptions)(
        <Input
          className={cx('input', className)}
          placeholder={placeholder}
          type={type}
          disabled={disabled}
          prefix={prefix}
          suffix={suffix}
          onBlur={onBlur}
          autoComplete={autoComplete}
        />,
      )}
    </FormItem>
  );
};

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  className: PropTypes.string,
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  type: PropTypes.string,
  disabled: PropTypes.bool,
  fieldClassName: PropTypes.string,
  fieldOptions: PropTypes.shape({}),
  form: PropTypes.shape({}).isRequired,
  onBlur: PropTypes.func.isRequired,
  autoComplete: PropTypes.string,
};

InputField.defaultProps = {
  placeholder: '',
  options: [],
  className: '',
  prefix: '',
  suffix: '',
  type: '',
  dropdownClassName: '',
  optionClassName: '',
  disabled: false,
  fieldClassName: '',
  fieldOptions: {},
  onBlur: () => {},
  autoComplete: undefined,
};

export default InputField;
